<cc-box>
  <div class="lg-container" box header >{{'LEAD_GENERATION.SHARED.DEFAULT_COUNTRY' | translate}}</div>
  <div box content>
    <div class="grey-100 grey-text p-a-md">{{'LEAD_GENERATION.SHARED.DEFAULT_COUNTRY_COMMENT' | translate}}</div>
    <div layout class="justify-content-space-between align-item-center lg-container">
      <div class="flex-1">{{'LEAD_GENERATION.SHARED.PREFIX' | translate}} </div>
      <cc-phone-numbers-dropdown class="phone-number-dropdown"
                                 (change)="changeSelectedNumber($event)"
                                 [initialCountryCode]="popupSettings.controls.forcedCountryCode.value">
      </cc-phone-numbers-dropdown>

    </div>
  </div>
</cc-box>
